import { CheckedCsvInviteUser, CsvInviteUser, UserInvitationResult } from '../../../../store/auth/auth'

export enum ActionType {
  CSV_FILE_UPLOADED,
  CSV_CLIENT_VERIFICATION_STARTED,
  CSV_CLIENT_VERIFICATION_COMPLETED,
  CSV_SERVER_VERIFICATION_STARTED,
  CSV_SERVER_VERIFICATION_COMPLETED,
  INVITE_START_INVITATION_LOADING,
  INVITE_PROCESSED_INVITATION_COUNT_CHANGED,
  INVITE_RESULT_CHANGED,
  INVITE_COMPLETED,
  RESET,
}

export interface ResetContext {
  type: ActionType.RESET
}

// ---------------------------------------------------
// csv verification
// ---------------------------------------------------
export interface CsvFileUploadedContext {
  type: ActionType.CSV_FILE_UPLOADED
  payload: string
}

export interface CsvClientVerificationStartedContext {
  type: ActionType.CSV_CLIENT_VERIFICATION_STARTED
}

export interface CsvClientVerificationCompletedContext {
  type: ActionType.CSV_CLIENT_VERIFICATION_COMPLETED
  payload: {
    users: CsvInviteUser[]
    errorMessage: string | null
  }
}

export interface CsvServerVerificationStartedContext {
  type: ActionType.CSV_SERVER_VERIFICATION_STARTED
}

export interface CsvServerVerificationCompletedContext {
  type: ActionType.CSV_SERVER_VERIFICATION_COMPLETED
  payload: {
    users: CheckedCsvInviteUser[]
    errorMessages: string[]
  }
}

// ---------------------------------------------------
// invitation
// ---------------------------------------------------
export interface StartInvitationLoadingContext {
  type: ActionType.INVITE_START_INVITATION_LOADING
}

export interface ProcessedInvitationCountContext {
  type: ActionType.INVITE_PROCESSED_INVITATION_COUNT_CHANGED
  payload: number
}

export interface InvitationResultChangedContext {
  type: ActionType.INVITE_RESULT_CHANGED
  payload: UserInvitationResult[]
}

export interface InvitationCompletedContext {
  type: ActionType.INVITE_COMPLETED
}

export type BulkInviteContextActions =
  | CsvFileUploadedContext
  | CsvClientVerificationStartedContext
  | CsvClientVerificationCompletedContext
  | CsvServerVerificationStartedContext
  | CsvServerVerificationCompletedContext
  | StartInvitationLoadingContext
  | ProcessedInvitationCountContext
  | InvitationResultChangedContext
  | InvitationCompletedContext
  | ResetContext
